import { useState, type ReactNode } from 'react';
import { Checkbox, Dialog } from './ui.js';

/**
 * Deleting a contact or a lead (round 2, point C): what happens in the
 * portal said plainly, and, for a record already in HubSpot, "Also delete
 * it in HubSpot", never ticked by default.
 */
export function DeleteDialog({
  title,
  children,
  inHubSpot,
  hubspotLabel,
  onCancel,
  onDelete,
}: {
  title: string;
  children: ReactNode;
  /** The record is in HubSpot: the box is offered. */
  inHubSpot: boolean;
  hubspotLabel: string;
  onCancel(): void;
  onDelete(alsoHubSpot: boolean): void;
}) {
  const [alsoHubSpot, setAlsoHubSpot] = useState(false);
  return (
    <Dialog
      small
      title={title}
      onClose={onCancel}
      footer={
        <>
          <button type="button" className="btn" autoFocus onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="btn primary"
            onClick={() => onDelete(inHubSpot && alsoHubSpot)}
          >
            Delete
          </button>
        </>
      }
    >
      <p className="dlg-text">{children}</p>
      {inHubSpot && (
        <Checkbox checked={alsoHubSpot} onChange={(e) => setAlsoHubSpot(e.target.checked)}>
          {hubspotLabel}
        </Checkbox>
      )}
    </Dialog>
  );
}
